
<template>
  <div class="home_wrap" :style="{ backgroundColor: f }">
    <div class="red_top_bg">
			<div class="language" @click="$router.push('/language')">
				<img :src="require('../images/language/'+lang+'.png')">
			</div>
		    <div class="search_box" @click="$router.push('/search')">
		        <i class="fdj"></i>
		        <input type="text" readonly :placeholder="$t('index.search')" class="search_inp">
		        <div class="clear_inp"></div>
		    </div>
			<div class="msg" @click="$router.push('/notice')">
				<img src="../images/index/msg.png">
			</div>
		</div>
    <div class="header-img flex" :style="{ backgroundColor: f }">
        <svg class="hd-left-img" viewBox="0 0 164 30"><defs><path id="a" d="M157.725 29.99H.01V.048h157.715z"></path></defs><g fill="none" fill-rule="evenodd"><path d="M160.352 24.069v-.449h.288c.157 0 .371.012.371.204 0 .208-.11.245-.296.245h-.363m0 .315h.192l.447.784h.49l-.494-.816c.255-.019.465-.14.465-.484 0-.427-.295-.565-.793-.565h-.721v1.865h.414v-.784m2.098-.146c0-1.095-.851-1.73-1.8-1.73-.955 0-1.805.635-1.805 1.73s.85 1.733 1.805 1.733c.948 0 1.8-.638 1.8-1.733m-.52 0c0 .798-.587 1.334-1.28 1.334v-.006c-.713.006-1.289-.53-1.289-1.328 0-.797.577-1.331 1.289-1.331.694 0 1.28.534 1.28 1.331" fill="#1A1919"></path><mask id="b" fill="#fff"><use href="#a"></use></mask><path d="m96.374 5.707.002 19.66h5.552V5.707h-5.554zm-43.677-.026v19.686H58.3V10.086l4.37.014c1.437 0 2.43.345 3.123 1.084.879.936 1.237 2.444 1.237 5.205v8.978h5.427V14.49c0-7.763-4.948-8.81-9.789-8.81h-9.97zm52.617.027v19.659h9.006c4.798 0 6.364-.798 8.057-2.587 1.198-1.256 1.971-4.014 1.971-7.027 0-2.763-.655-5.228-1.797-6.763-2.057-2.745-5.02-3.282-9.445-3.282h-7.792zm5.508 4.28h2.387c3.463 0 5.703 1.556 5.703 5.591 0 4.037-2.24 5.592-5.703 5.592h-2.387V9.989zm-22.453-4.28-4.634 15.58-4.44-15.579-5.993-.001 6.34 19.659h8.003l6.391-19.659H88.37zm38.563 19.659h5.553V5.709l-5.555-.001.002 19.659zm15.564-19.652-7.753 19.645h5.475l1.227-3.472h9.175l1.161 3.472h5.944l-7.812-19.646-7.417.001zM146.1 9.3l3.364 9.204h-6.833l3.47-9.204z" fill="#000" mask="url(#b)"></path><path d="M16.889 8.985V6.28c.262-.02.528-.033.798-.042 7.4-.232 12.255 6.359 12.255 6.359s-5.244 7.282-10.866 7.282a6.82 6.82 0 0 1-2.187-.35v-8.204c2.88.348 3.46 1.62 5.192 4.508l3.852-3.248s-2.812-3.688-7.552-3.688c-.515 0-1.008.036-1.492.088zm0-8.938V4.09c.265-.021.531-.038.798-.048 10.29-.346 16.995 8.44 16.995 8.44s-7.7 9.364-15.723 9.364c-.735 0-1.424-.068-2.07-.183v2.498c.553.07 1.126.112 1.724.112 7.465 0 12.864-3.812 18.092-8.325.867.694 4.416 2.383 5.145 3.123-4.971 4.16-16.555 7.515-23.123 7.515a18.89 18.89 0 0 1-1.838-.096V30h28.375V.047H16.89zm0 19.482v2.133c-6.905-1.23-8.822-8.408-8.822-8.408s3.316-3.674 8.822-4.269v2.34l-.011-.001c-2.89-.347-5.147 2.353-5.147 2.353s1.265 4.544 5.158 5.852zM4.625 12.943s4.092-6.04 12.264-6.663V4.088C7.838 4.815 0 12.48 0 12.48s4.439 12.833 16.889 14.008V24.16C7.753 23.011 4.625 12.943 4.625 12.943z" fill="#76B900" mask="url(#b)"></path></g></svg>
      <div class="hd-right">
      </div>
    </div>

    <van-swipe :autoplay="2500" class="swiper-container" @change="onChange">
      <van-swipe-item v-for="(image, index) in data.banner" :key="index">
        <router-link :to="image.url">
          <img :src="image[lang]" />
            <div class="swipe_content">{{image['content']}}</div>
        </router-link>
      </van-swipe-item>
      <!-- <template #indicator>
    <div class="custom-indicator">{{ current + 1 }}/4</div>
  </template> -->
      <!-- <div ref="dian" slot="indicator" class="custom-indicator">
        <div
          v-for="(img, x) in data.banner"
          :key="x"
          :class="x === 0 ? 'selected' : ''"
        />
      </div> -->
    </van-swipe>
<!--    <div class="lucky-user">-->
<!--      <ul class="user-list" :style="`animation-duration: ${luckyUsers.length * 10}s;`">  &lt;!&ndash; 内容区容器 &ndash;&gt;-->
<!--        <li v-for="(item, index) in luckyUsers" :key="index">-->
<!--          {{ item[0] }}<span style="color:red"> {{ item[1] }} </span>{{ item[2] }}<span style="color:red"> {{ item[3] }}</span>-->
<!--        </li>   &lt;!&ndash; 内容A &ndash;&gt;-->
<!--        <li v-for="(item, index) in luckyUsers" :key="index+'copy'">{{ item }}</li>  &lt;!&ndash; 内容B &ndash;&gt;-->
<!--      </ul>-->
<!--    </div>-->
    <div v-show="loading" class="work_box">
      <div class="item" style="width: 25%;" @click="$router.push('/about/5')">
        <div class="item_img">
            <img src="@/assets/images/welfare.svg">
        </div>
        <p class="item_title">{{ $t("Newcomer benefits") }}</p>
      </div>

	  <div class="item" style="width: 25%;" @click="$router.push('/about/4')">
	    <div class="item_img">
            <img src="@/assets/images/about.svg">
	    </div>
	    <p class="item_title">{{ $t("About") }}</p>
	  </div>

      <div class="item" style="width: 25%;" @click="$router.push('/faq')">
        <div class="item_img">
            <img src="@/assets/images/faq.svg">
        </div>
        <p class="item_title">{{ $t("FAQ") }}</p>
      </div>
      <div class="item" style="width: 25%;" @click="$router.push('/share')">
        <div class="item_img">
            <img src="@/assets/images/invite.svg">
        </div>
        <p class="item_title">{{ $t("Invite") }}</p>
      </div>
    </div>
    <div v-show="!loading" class="work_box query">
      <div v-for="i in 10" class="item" :key="i">
        <div class="item_img" />
        <p class="item_title" />
      </div>
    </div>

    <div class="ads_box_1">
<!--        <div class="ads_img">-->
      <div class="ads_img" @click="$router.push('/chip')">
          <img src="@/assets/images/chip/entrance.jpg" alt="" />
      </div>
      <div class="ads-text">{{ $t("About Autonomous Vehicles") }}</div>
    </div>

    <div class="player-container">
      <video-player style="width: 100%; height: 100%" class="video-player vjs-custom-skin" ref="videoPlayer"
        :playsinline="true" :options="playerOptions"></video-player>
    </div>

    <div class="ads-text" style="margin-top: 30px;">{{ $t("index.hb") }}</div>
      <div class="footer-scroll mt-20">
          <div class="scroll-content">
              <img v-for="(item, index) in brands" :key="index" :src="item.src" class="brand-logo" />
              <!-- 复制一份，实现无缝衔接 -->
              <img v-for="(item, index) in brands" :key="'copy'+index" :src="item.src" class="brand-logo" />
          </div>
      </div>
      <div class="news">
          <div class="news-title">
              <div class="left">{{$t('News')}}</div>
              <div class="right" @click="$router.push('/news')">
                  {{$t('More')}}
                  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 612"><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"></path></svg>
              </div>
          </div>
          <div class="list">
              <div class="item" v-for="(news, index) in newsList" :key="index" @click="$router.push({ path: '/about/' + news.id })">
                  <div class="item-img">
                      <img :src="news.img">
                  </div>
                  <div class="item-content">
                      <div class="item-title">{{ news.title }}</div>
                      <div class="item-desc">{{ news.publish_time }}</div>
                  </div>
              </div>
          </div>
      </div>

      <div style="height: 90px;"></div>

    <van-dialog v-model="show_tc" :confirmButtonText="$t('utils.confirm')" @confirm="confirmPop">
      <div class="popup" v-html="tc_content"></div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import Api from "../../interface/index";

import { Swipe, SwipeItem, Icon, Progress, Dialog, Field } from "vant";

Vue.use(Icon).use(Progress).use(Dialog).use(Field);

export default {
  name: "Index",
  components: {
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem,
  },
  inject: ['reload'],
  data() {
    return {
      luckyUsers: [
        ['Usuario 8 ****2151' ,'el Anuncio v 2', 'ingresos totales:','6000'],
        ['Usuario 5 ****3311' ,'el anuncio v 3', 'ingresos totales:','18000'],
        ['Usuario 4 ****6741' ,'el anuncio v 3', 'ingresos totales:','18000'],
        ['Usuario 6 ****2221' ,'el anuncio v 2', 'ingresos totales:','6000'],
        ['Usuario 5 ****3321' ,'el anuncio v 4', 'ingresos totales:','42000'],
        ['Usuario 5 ****5663' ,'el anuncio v 3', 'ingresos totales:','18000'],
        ['Usuario 4 ****7564' ,'el anuncio v 2', 'ingresos totales:','6000'],
        ['Usuario 6 ****3881' ,'el anuncio v 4', 'ingresos totales:','42000'],
        ['Usuario 5 ****5221' ,'el anuncio v 3', 'ingresos totales:','18000'],
        ['Usuario 8 ****2151' ,'el anuncio v 2', 'ingresos totales:','6000'],
        ['Usuario 4 ****2311' ,'el anuncio v 2', 'ingresos totales:','6000'],
        ['Usuario 4 ****3951' ,'el anuncio v 4', 'ingresos totales:','42000'],
        ['Usuario 3 ****2431' ,'el anuncio v 3', 'ingresos totales:','18000'],
        ['Usuario 5 ****3551' ,'el anuncio v 2', 'ingresos totales:','6000'],
        ['Usuario 3 ****6665' ,'el anuncio v 4', 'ingresos totales:','42000'],
        ['Usuario 3 ****7881' ,'el anuncio v 3', 'ingresos totales:','18000'],
        ['Usuario 8 ****6642' ,'el anuncio v 4', 'ingresos totales:','42000'],
      ],
      byFlag: localStorage.getItem("byFlag") || 'false',
      f: localStorage.getItem("f") || "#fff",
      lang: this.$i18n.locale || "en_us",
      show_kefu: false,
      msg_show: true,
      loading: false,
      icon: [],
      data: {},
      show_img: false,
      show_tz: false,
      show_tc: false,
      tc_content: "",
      number: "",
      sku: [],

      playerOptions: {
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        // aspectRatio: '9:16', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        // aspectRatio: "750:1466",
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            // type: "video/mp4",
			      src:"https://api.nvidia-chips.vip/upload/nvidia.MOV"
          },
        ],
        // poster: "/static/video/hover_1.jpg", //你的封面地址
        poster: "", //你的封面地址
        notSupportedMessage: "No Player",
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      userName:'',
        newsList:[],
        brands: [
            { src: require("@/assets/images/brand/benz.svg") },
            { src: require("@/assets/images/brand/byd.svg") },
            { src: require("@/assets/images/brand/hyundai.svg") },
            { src: require("@/assets/images/brand/li.png") },
            { src: require("@/assets/images/brand/lucid.jpg") },
            { src: require("@/assets/images/brand/rivian.png") },
            { src: require("@/assets/images/brand/toyota.svg") },
            { src: require("@/assets/images/brand/volvo.svg") },
            { src: require("@/assets/images/brand/xiaomi.svg") },
        ],
    };
  },
  created()
  {
    this.$parent.footer("index");
    // localStorage.setItem("lang", "zh_cn");
  },
  mounted() {
      this.getNewsList();
    this.start();
    this.getUser();
    //代理标识设置
    if (this.$router.history.current.query.agent) {
      localStorage.setItem("agent", this.$router.history.current.query.agent);
    }
    console.log();
    var that = this;
    document.body.addEventListener(
      "scroll",
      function () {
        if (!that.show_kefu) {
          return;
        }
        that.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target.className != "kefu_img") {
          that.show_kefu = false;
        }
      },
      false
    );
  },
  methods: {
      getNewsList() {
          Fetch('/index/news', { }).then(res => {
              this.newsList = res.data.list;
          })
      },
    byFlagChange(e) {
      if (e == "r") {
        localStorage.setItem("f", "#47b897");
        localStorage.setItem("byFlag", 'false');
        this.reload()
      } else {
        localStorage.setItem("f", "#282828");
        localStorage.setItem("byFlag", 'true');
        this.reload()
      }
    },
    toKefu() {
      // const dom = document.getElementById('apbd-cht-btn');
      // dom.click();
      Fetch('/index/webconfig', {type: 'web'}).then(res => {
        this.data = res.data;
        // window.location.href = res.data.kefu_link;
        let link=res.data.kefu_link;
        link=link.replace('{0}',this.userName);
        console.log(this.userName)
        window.location.href = link;
      })
    },
    kefu_to() {
      if (this.show_kefu) {
        this.$router.push("/kefu");
      }
      this.show_kefu = !this.show_kefu;
    },
    hideDown() {
      this.show_img = false;
      this.$store.commit("setShowAdvert", false);
    },
    start() {
      Fetch("/index/int").then((r) => {
        //打包web请注释掉版本更新这段代码
        //-----------------------------------------
        // if(window.plus){
        // let appVersion1 = plus.runtime.version;
        // let appVersion2 = r.data.version.app_version;
        // //版本号不同则更新APP
        // if(parseInt(appVersion1.split(".").join(""))<parseInt(appVersion2.split(".").join(""))){
        // 	this.$dialog.alert({
        // 	  title: 'APP更新',
        // 	  message: r.data.version.app_instructions,
        // 	}).then(() => {
        // 		let u = navigator.userAgent;
        // 		let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
        // 		let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // 		if (isAndroid) {
        // 		 // alert("我是安卓");
        // 			window.location.href = r.data.version.android_app_down_url;
        // 		}
        // 		if (isIOS) {
        // 		 // alert("我是苹果");
        // 		 window.location.href = r.data.version.ios_app_down_url;
        // 		}
        // 	});
        // }
        // }
        //-----------------------------------------
        this.data = r.data;
        this.loading = true;
        let indexPop = localStorage.getItem("indexPop") || 1;
        if (r.data.popup.show == 1 && indexPop == 1) {
          this.tc_content = r.data.popup.content;
          this.show_tc = true;
        }
      });
    },
    confirmPop() {
      localStorage.setItem("indexPop", 2);
    },
    onChange() {
      //   let els = this.$refs.dian.querySelectorAll("div");
      //   for (let i = 0; i < els.length; i++) {
      //     els[i].className = "";
      //   }
      //   els[index].className = "selected";
    },
    buy(item) {
      this.sku = item;
      this.show_tz = true;
    },
    confirm() {
      if (!this.number) {
        this.$toast(this.$t("item.inputAmount"));
        return false;
      }
      Fetch("/index/item_apply", {
        id: this.sku.id,
        money: this.number,
      })
        .then((r) => {
          this.$router.push("/order");
        })
        .catch((err) => {
          this.psd_val = "";
        });
    },
	toForward(){
		window.location.href='https://alfaglobal.uk/';
	},
    getUser(){
      Fetch("/user/info").then((r) => {
        let data = r.data;
        this.userName=data.name ? data.name : data.mobile;
      });
    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-cell {
  padding: 15px 26px;
}

.home_wrap {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
}

.footer-ul {
    display: flex;
    flex-wrap: wrap; /* 允许换行 */
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    margin-top: 20px;
}

.footer-ul .footer-li {
    background-color: #fff;
    position: relative;
    width: calc(33.333% - 10px); /* 一行三个，减去间距 */
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px; /* 行间距 */
}

.footer-ul .footer-li img {
    height: 70px;
    max-width: 100%;
}

.player-container {
  width: calc(100% - 30px);
  height: 180px;
  margin: 20px auto;
}

.ads-text {
  font-size: 16px;
  font-family: PingFang;
  font-weight: 400;
  color: #7e7e7e;
  text-align: center;
  margin: 15px 0;
}

.header-img {
  position: fixed;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 54px;
  padding: 0 20px;

  .hd-left-img {
    /*width: 160px;*/
    height: 26px;
  }

  .hd-right {
    display: flex;
    justify-content: center;
    align-items: center;

    .language {
      height: 30px;

      img {
        height: 100%;
      }
    }

    .btorhy {
      height: 25px;
    }
  }
}

.red_top_bg {
  position: fixed;
  top: 0;
  z-index: 10;

  .language {
    position: absolute;
    top: 4px;
    left: 0;
    height: 36px;

    img {
      height: 100%;
    }
  }

  .msg {
    position: absolute;
    top: 9px;
    right: 6px;
    height: 23px;

    img {
      height: 100%;
    }
  }
}

.search_box {
  width: 80%;
  height: 29px;
  background-color: #f6f6f6;
  border-radius: 17px;
  margin: 8px 40px 0 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px 0 14px;

  .fdj {
    width: 16px;
    height: 16px;
    background: url(../images/item/fdj.png) no-repeat center center;
    background-size: 100% 100%;
  }

  .search_inp {
    flex: 1;
    margin: 0 8px;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    height: 20px;
  }

  .clear_inp {
    width: 20px;
    height: 20px;
    background: url(../images/item/clear.png) no-repeat center center;
    background-size: 100% 100%;
  }
}

.swiper-container {
  width: 100%;
  height: 180px;
  margin-top: 54px;
  // background: #ffffff;

  .van-swipe-item {
    overflow: hidden;
  }

  a {
    float: left;
    width: 100%;
    height: 100%;
  }

  img {
    // border-radius: 6px;
    // margin-left: 2%;
    height: 85%;
    width: 100%;
  }

  /deep/ .van-swipe__indicator {
    background-color: #999;
  }

  /deep/ .van-swipe__indicator--active {
    width: 13px;
    background-color: #d7a659;
    border-radius: 30%;
  }
}


.work_box.query {
  .item {
    .item_img {
      border-radius: 5px;
      background: #76b900;
    }

    .item_title {
      width: 100%;
      height: 14px;
      margin-left: 0;
      background: #f0f0f0;
        color: #000;
    }
  }
}

.ads_box_1 {
  border-radius: 5px;
  margin-top: 10px;
  text-align: center;

  .ads_img {
    /*height: 100px;*/

    img {
      width: 90%;
      border-radius: 5px;
      height: 100%;
      object-fit: cover;
    }
  }
}

.ads_box {
  // background: rgba(255, 255, 255, 1);
  width: 97%;
  border-radius: 13px;
  margin: 10px auto 0 auto;
  display: flex;
  text-align: center;

  .ads_img {}

  img {
    width: 96%;
    border-radius: 5px;
  }
}

.items_1,
.items_2,
.items_3 {
  margin: 10px 2% 0 2%;
  width: 96%;

  .items_tit {
    border-radius: 5px 5px 0 0;
    height: 44px;
    line-height: 44px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.8);
    background: #ffffff;
    border-bottom: 1px solid #f7f7f7;
    padding: 0 14px;
    display: flex;
    justify-content: space-between;

    .tit_tip {
      display: contents;
      font-size: 12px;
      font-weight: normal;
      color: #b2b2b2;
      margin-left: 10px;
    }

    .tit_more {
      font-size: 12px;
      font-weight: normal;
      color: #b2b2b2;
    }
  }

  .item {
    background: #fff;
  }
}

.items_1 {
  .item {
    padding: 5px;
    margin: 0 0 10px 0;

    div {
      margin: 20px 0;
    }

    .item_tit {
      text-align: center;
      overflow: hidden;

      p {
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: bold;
        font-size: 16px;
      }
    }

    .item_rate {
      text-align: center;
      color: #ff0000;
      font-size: 22px;
      font-weight: bold;
    }

    .item_desc {
      display: flex;

      p {
        width: 50%;
        text-align: center;
      }
    }

    .item_btn {
      text-align: center;

      button {
        width: 60%;
        min-width: 60px;
        background: #e7544d;
        color: #ffffff;
        padding: 10px 0px;
        border-radius: 10px;
      }

      .item_btn_over {
        background: #999;
      }
    }
  }
}

.items_2 {
  .item {
    display: flex;
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #ececec;

    div {
      margin: 15px 0;
    }

    .item_rate {
      width: 20%;

      p {
        padding: 5px 0;
      }

      p:nth-child(1) {
        font-weight: bold;
        font-size: 14px;
        color: #ff0000;
      }

      p:nth-child(2) {
        color: #999;
      }
    }

    .item_tit {
      width: 55%;

      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 5px 0;
      }

      p:nth-child(1) {
        font-weight: bold;
      }

      p:nth-child(2) {
        color: #999;
      }
    }

    .item_btn {
      width: 25%;

      button {
        min-width: 60px;
        margin-top: 12px;
        color: #1989fa;
        padding: 5px 5px;
        border-radius: 5px;
        border: 1px solid #1989fa;
      }

      .item_btn_over {
        color: #999;
        border: 1px solid #999;
      }
    }
  }
}

.items_3 {
  .item {
    margin-bottom: 10px;

    div {
      margin: 5px 0;
    }

    .item_div1 {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ececec;
      padding: 15px 10px;

      p:nth-child(1) {
        // width: 70%;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      p:nth-child(2) {
        color: #999;
      }
    }

    .item_div2 {
      display: flex;
      justify-content: space-between;
      text-align: center;
      font-size: 14px;

      div {
        width: 33.33%;

        p {
          padding: 5px 0;
        }
      }

      .item_rate {
        p:nth-child(1) {
          font-weight: bold;
          color: #ff0000;
        }

        p:nth-child(2) {
          color: #999;
        }
      }

      .item_day {
        p:nth-child(1) {
          font-weight: bold;
        }

        p:nth-child(2) {
          color: #999;
        }
      }

      .item_min {
        p:nth-child(1) {
          font-weight: bold;
        }

        p:nth-child(2) {
          color: #999;
        }
      }
    }

    .item_div3 {
      color: #999;
      padding: 5px 10px;
    }

    .item_div4 {
      padding: 5px 10px;
      display: flex;
      justify-content: space-between;

      div:nth-child(1) {
        width: 75%;
        margin-top: 16px;
      }

      .item_btn {
        width: 20%;

        button {
          min-width: 60px;
          color: #1989fa;
          padding: 5px 5px;
          border-radius: 5px;
          border: 1px solid #1989fa;
        }

        .item_btn_over {
          color: #999;
          border: 1px solid #999;
        }
      }
    }
  }
}

.popup {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  max-height: 60vh;
  padding: 26px 24px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 20px;
}

.lucky-user {
  height: 30px;
  margin: 0 auto;
  font-size: 18px;
  line-height: 30px;
  color: #E9B65F;
  overflow: hidden; //超出内容隐藏
  .user-list {
    width: fit-content; // Q1
    white-space: nowrap; // 内容不换行
    animation-name: seamless-scrolling; // Q3
    animation-timing-function: linear; // 动画速度曲线，匀速
    animation-iteration-count: infinite; // 动画循环无限次播放
    li {
      display: inline-block;
      margin-right: 30px;
    }
  }
}

@keyframes seamless-scrolling {
  0% {
    transform: translateX(0px);
  }
  100% {
    transform: translateX(-50%); //Q2
  }
}
    .swipe_content {
        position: absolute;
        bottom: 50px;
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        padding: 0 30px;
        letter-spacing: 1.5;
    }

.footer-scroll {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
}
.scroll-content {
    display: inline-flex;
    animation: scroll 15s linear infinite;
}
.brand-logo {
    width: 80px;
    margin: 0 10px;
}
@keyframes scroll {
    from {
        transform: translateX(0);
    }
    to {
        transform: translateX(-50%);
    }
}
</style>
